import React from 'react';
import styled from 'styled-components';
import FadeInUp from '../../shared/Animation/FadeInUp';

const StyledWrap = styled.div`
  margin-bottom: 60px;
`;

function RowTablet({ children, icon, textRight }) {
  return (
    <StyledWrap className={`row${textRight ? ' text-right' : ''}`}>
      <div className="col-md-12">
        {
          !textRight &&
          <div className="col-md-2">
            {icon}
          </div>
        }
        <div className="col-md-10">
          {children}
        </div>
        {
          textRight &&
          <div className="col-md-2">
            {icon}
          </div>
        }
      </div>
    </StyledWrap>
  );
}

function RowMobile({ children, icon }) {
  return (
    <StyledWrap className={'text-center'}>
      <div className="col-md-12">
        <div className="col-md-2">
          {icon}
        </div>
        {children}
      </div>
    </StyledWrap>
  );
}

function Row(props) {
  const { isMobile } = props;
  return (
    <FadeInUp>
      {
        isMobile ?
          <RowMobile {...props} />
          : <RowTablet {...props} />
      }
    </FadeInUp>
  );
}

export default Row;



// WEBPACK FOOTER //
// ./src/components/landing/Statistics/Row.js